import React, { useEffect, useState } from "react";
import {
  Arrow,
  Button,
  Paragraph,
  Section,
  Span,
} from "../../Styles/Global.Styled";
import { css } from "styled-components";
import CheckmarkIcon from "../../Icons/CheckmarkIcon";
import { useNavigate } from "react-router-dom";

const redirectMain = css`
  padding: 5vh 0 20vh;
  align-items: center;
  gap: 2vh;
  /* border: 2px solid red; */
`;
const mainBttn = css`
  background-color: ${({ theme }) => theme.main};
  color: white;
  font-size: 1.25vh;
  border-radius: 25px;
  padding: 0.75vh 1vh;
  margin-left: 25vh;
  margin-top: 2vh;
  /* align-self: flex-end; */
`;
const arrowStyle = css`
  padding: 0.4vh;
  border-width: 0 0.35vh 0.35vh 0;
  border-color: white;
`;
const textStyle = css`
  font-size: 1.5vh;
  text-align: center;
`;
const footerStyle = css`
  font-size: 1vh;
  font-style: italic;
`;
const titleStyle = css`
  font-family: "Courier New";
  font-size: 3.5vh;
  font-weight: 600;
  text-align:center;
  /* margin-top: -5%; */
`;

const Message = ({ header, message, redirectTo, cta, type }) => {
  const [remainingTime, setRemainingTime] = useState(60);
  const navigate = useNavigate();

  useEffect(() => {
    if (!redirectTo) return;

    const timer = setInterval(() => {
      setRemainingTime((prev) => {
        if (prev === 1) {
          navigate(redirectTo); // Redirect when time reaches 0
          clearInterval(timer);
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [redirectTo, navigate]);

  return (
    <Section $baseStyle={redirectMain}>
      {type === "success" && (
        <CheckmarkIcon style={{ height: "10vh", width: "10vh" }} />
      )}
      <Paragraph $baseStyle={titleStyle}>{header}</Paragraph>
      <Paragraph $baseStyle={textStyle}>{message}</Paragraph>
      {redirectTo && (
        <Span $baseStyle={footerStyle}>
          we will be redirected to our shop in {remainingTime} seconds.
        </Span>
      )}
      {cta && (
        <Button $baseStyle={mainBttn} onClick={() => navigate(redirectTo)}>
          {cta}
          <Arrow $direction="right" $baseStyle={arrowStyle} />
        </Button>
      )}
    </Section>
  );
};

export default Message;
